import React from "react";
/** Components Import */
import { Card, CardBody } from "react-bootstrap";
import {} from "../../Components/Bootstrap";

function Terms({}) {
  return (
    <Card>
      <Card.Body className="terms-card-body">
        <p>
          부산광역시 버스 운송사업조합에서는 다음과 같이 귀하의 개인정보를 수집
          및 이용하고자 합니다. 내용을 자세히 읽으신 후 동의 여부를 결정하여
          주시기 바랍니다.
        </p>
      </Card.Body>
      <Card.Header className="terms-card-header">
        개인정보 수집 &#183; 이용내역
      </Card.Header>
      <Card.Body className="terms-card-body">
        <ul className="terms-ul-container">
          <li>수집 항목</li>
          <ul>
            <li>
              사번, 비밀번호, 성명, 소속기관, 교육 계획 및 이력, 휴무 계획 및
              이력, 근무 계획 및 이력, 음주 측정 값(정상/비정상)
            </li>
          </ul>
          <li>수집 목적</li>
          <ul>
            <li>운영관리 표준화 시스템 운영</li>
            <li>배차정보 제공</li>
            <li>노선별 운행차량 실시간 모니터링</li>
            <li>사용자 인증 및 권한 관리</li>
          </ul>
          <li>보유 및 이용 기간</li>
          <ul>
            <li>
              해당 서비스 제공 기간 및 서비스 종료일로부터 1년. 단, 업무 이력
              관리 정보는 준영구
            </li>
          </ul>
        </ul>
      </Card.Body>
      <div className="divider" />
      <CardBody className="terms-card-body">
        <p className="terms-finish-p">
          &#164; 수집된 자료는 운행관리 표준화 시스템의 원활한 운영을 위하여
          귀하가 재직중인 회사 및 관계기관에 최소한의 정보를 제공할 수 있습니다.
        </p>
        <p className="terms-finish-p">
          &#164; 귀하는 위와 같은 개인정보 수집 및 이용에 동의하지 않을 권리가
          있습니다.
          <br />
          다만, 동의를 거부하실 경우 운행관리 표준화 시스템 이용이 불가능합니다.
        </p>
      </CardBody>
    </Card>
  );
}

export default Terms;
